import { Flex } from "antd";
import { ImpressaoContainer, ImpressaoHeader } from "components/Impressao";
import type { ApiProdutor } from "pages/produtores/types/ApiProdutor";
import { useMemo } from "react";
import { TableCard } from "./TableCard";

export function TableRelCadastroProdutor({ data, title }: { data: ApiProdutor[] | undefined; title: string }) {
	const rows = useMemo(() => (data || []).map((row) => <TableCard produtor={row} key={row?.for_idpk} />), [data]);

	return (
		<ImpressaoContainer className="w-full mt-3" title={title}>
			<ImpressaoHeader title={title} />

			<Flex vertical={true} gap={"12px"} style={{ width: "100%" }}>
				{rows}
			</Flex>
		</ImpressaoContainer>
	);
}
